import { BUSINESS_UUID } from '../../utils/constants';

export const bankId = (state) => state.config.get('bank_id');
export const brandId = (state) => state.config.get('brand_id');
export const accessToken = (state) => state.config.get('access_token');
export const business_uuid = (state) => state.config.get(BUSINESS_UUID);
export const apiBaseUrlLiberty = (state) => state.config.get('apiBaseUrlLiberty');
export const stubsEnabled = (state) => state.config.get('stubs');
